<template>
  <app-logged id="PendenciasIndex">
    <v-flex
      xs12
    >
      <app-widget>
        <div slot="widget-content">
          <v-list
            v-if="listOfPendencies.length > 0"
            two-line
          >
            <v-list-item
              v-for="(item, i) in listOfPendencies"
              :key="i"
              :disabled="!$route.meta.routeToEdit"
              @click="goToEdit(item.id)"
            >
              <v-list-item-avatar>
                <v-avatar
                  color="secondary"
                  size="40"
                >
                  <v-icon dark>
                    {{ $route.meta.iconList }}
                  </v-icon>
                </v-avatar>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title v-text="$options.filters.date(item[$route.meta.titleText])" />
                <v-list-item-subtitle
                  class="grey--text"
                  v-text="item[$route.meta.subtitleText]"
                />
              </v-list-item-content>
              <v-list-item-action>
                <v-icon color="grey lighten-1">
                  arrow_forward_ios
                </v-icon>
              </v-list-item-action>
            </v-list-item>
          </v-list>
          <v-list v-else>
            <v-list-item>
              <v-list-item-avatar>
                <v-icon class="black lighten-2 white--text">
                  thumb_down
                </v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title v-text="$route.meta.emptyList" />
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </div>
      </app-widget>
    </v-flex>
  </app-logged>
</template>

<script>
import AppLogged from '@/components/layouts/AppLogged'
import AppWidget from '@/components/AppWidget'
import Store from '@/store'
export default {
  name: 'PendenciasIndex',
  components: {
    AppWidget,
    AppLogged
  },
  data () {
    return {
      listOfPendencies: []
    }
  },
  created () {
    this.listOfPendencies = Store.getters[this.$route.meta.pendenciesFromRoute]
  },
  methods: {
    goToEdit (id) {
      this.$router.push({
        name: this.$route.meta.routeToEdit,
        params: {
          id
        }
      })
    }
  }
}
</script>
